//載入相關語系檔
import en from "./en";
import zh_tw from "./zh-tw";
import zh_cn from "./zh-cn";
import ja from "./ja";

//檔名匹配
const messagesMap = {
  "en": en,
  "zh-tw": zh_tw,
  "zh-cn": zh_cn,
  "ja": ja
};

export default messagesMap;
